const Home 					= () => import(/* webpackChunkName: "home" */ '@/views/Home.vue');
const HomepageProductLists 	= () => import(/* webpackChunkName: "homepage-product-lists" */ '@/views/HomepageProductLists.vue');
const HomepageProductDetail = () => import(/* webpackChunkName: "homepage-product-detail" */ '@/views/HomepageProductDetail.vue');
const HomepageProductSupplier = () => import(/* webpackChunkName: "homepage-product-supplier" */ '@/views/HomepageProductSupplier.vue');
const HomepageProductWishlist = () => import(/* webpackChunkName: "homepage-product-wishlist" */ '@/views/HomepageProductWishlist.vue');
const Page 				= () => import(/* webpackChunkName: "page" */ '@/views/Page.vue');
const Login 			= () => import(/* webpackChunkName: "login" */ '@/views/Login.vue');
const Register 			= () => import(/* webpackChunkName: "register" */ '@/views/Register.vue');
const RegisterSupplier 	= () => import(/* webpackChunkName: "register-supplier" */ '@/views/RegisterSupplier.vue');
const Welcome 			= () => import(/* webpackChunkName: "welcome" */ '@/views/Welcome.vue');
const ResetPassword 	= () => import(/* webpackChunkName: "reset-password" */ '@/views/ResetPassword.vue');
const Profile 			= () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue');
const Products 			= () => import(/* webpackChunkName: "products" */ '@/views/Products.vue');
const ProductCreator 	= () => import(/* webpackChunkName: "ostock-product-creator" */ '@/views/inventro/ProductCreator.vue');
const ProductDropship 	= () => import(/* webpackChunkName: "product-dropship" */ '@/views/ProductDropship.vue');
const Submissions 		= () => import(/* webpackChunkName: "orders" */ '@/views/Submissions.vue');
const SubmissionDetails = () => import(/* webpackChunkName: "submission-details" */ '@/views/SubmissionDetails.vue');
const Settings 			= () => import(/* webpackChunkName: "settings" */ '@/views/Settings.vue');
const SettingsCallback 	= () => import(/* webpackChunkName: "SettingsCallback" */ '@/views/SettingsCallback.vue');
const Changelog 		= () => import(/* webpackChunkName: "changelog" */ '@/views/Changelog.vue');
const Wallet 			= () => import(/* webpackChunkName: "wallet" */ '@/views/Wallet.vue');
const WalletStash 		= () => import(/* webpackChunkName: "wallet" */ '@/views/WalletStash.vue');
const HandlingFee 		= () => import(/* webpackChunkName: "handling-fee" */ '@/views/HandlingFee.vue');
// const Billings 			= () => import(/* webpackChunkName: "billings" */ '@/views/Billings.vue');
// const BillingsRedirect 	= () => import(/* webpackChunkName: "billings-redirect" */ '@/views/BillingsRedirect.vue');
const Inventory 		= () => import(/* webpackChunkName: "inventory" */ '@/views/Inventory.vue');

const Members 			= () => import(/* webpackChunkName: "members" */ '@/views/Members.vue');
const MemberCreator 	= () => import(/* webpackChunkName: "member-creator" */ '@/views/MemberCreator.vue');

const SettingsCustomerFile 	= () => import(/* webpackChunkName: "settings-customer-file" */ '@/views/SettingsCustomerFile.vue');
const SettingsNotification 	= () => import(/* webpackChunkName: "settings-notification" */ '@/views/SettingsNotification.vue');
const SettingsAutoresponder = () => import(/* webpackChunkName: "settings-autoresponder" */ '@/views/SettingsAutoresponder.vue');
const SettingsConnection = () => import(/* webpackChunkName: "settings-connection" */ '@/views/SettingsConnection.vue');
const SettingsCustomDomain 	= () => import(/* webpackChunkName: "settings-custom-domain" */ '@/views/SettingsCustomDomain.vue');
const SettingsPayment 		= () => import(/* webpackChunkName: "settings-payment" */ '@/views/SettingsPayment.vue');
const SettingsSms 			= () => import(/* webpackChunkName: "settings-sms" */ '@/views/SettingsSms.vue');
const SettingsWhatsApp 		= () => import(/* webpackChunkName: "settings-whatsapp" */ '@/views/SettingsWhatsApp.vue');
const SettingsStore 		= () => import(/* webpackChunkName: "settings-store" */ '@/views/SettingsStore.vue');
const SettingsWarehouse 	= () => import(/* webpackChunkName: "settings-warehouse" */ '@/views/SettingsWarehouse.vue');
const SettingsGeneral 		= () => import(/* webpackChunkName: "settings-general" */ '@/views/SettingsGeneral.vue');
const SettingsTag 			= () => import(/* webpackChunkName: "settings-tag" */ '@/views/SettingsTag.vue');
const SettingsShipping		= () => import(/* webpackChunkName: "settings-tag" */ '@/views/SettingsShipping.vue');
const SettingsTracking 		= () => import(/* webpackChunkName: "settings-tag" */ '@/views/SettingsTracking.vue');

const ConnectionCallback	= () => import(/* webpackChunkName: "connection-callback" */ '@/views/ConnectionCallback.vue');
const AuthCallback			= () => import(/* webpackChunkName: "auth-callback" */ '@/views/AuthCallback.vue');

const Brand 				= () => import(/* webpackChunkName: "brand" */ '@/views/Brand.vue');
const BrandList 			= () => import(/* webpackChunkName: "brand-list" */ '@/views/BrandList.vue');
const Direct 				= () => import(/* webpackChunkName: "direct" */ '@/views/Direct.vue');
const DirectList 			= () => import(/* webpackChunkName: "direct-list" */ '@/views/DirectList.vue');
const ProductRequest		= () => import(/* webpackChunkName: "product-request" */ '@/views/ProductRequest.vue');
const ProductRequestList	= () => import(/* webpackChunkName: "product-request-list" */ '@/views/ProductRequestList.vue');

const PageNotFound			= () => import(/* webpackChunkName: "page-not-found" */ '@/views/PageNotFound.vue');
const PageUnauthorized		= () => import(/* webpackChunkName: "page-unauthorized" */ '@/views/PageUnauthorized.vue');

const NotificationCenter	= () => import(/* webpackChunkName: "notification-center" */ '@/views/AdminNotificationCenter.vue');
const PhoneVerification	= () => import(/* webpackChunkName: "phone-verification" */ '@/views/PhoneVerification.vue');

const APP_NAME = process.env.VUE_APP_NAME;

const generalRoutes = [
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: {
			layout: 'Main',
			title: `${APP_NAME}`,
			gtm: `${APP_NAME}`,
		},
	},
	{
		path: '/search',
		name: 'search',
		component: HomepageProductLists,
		meta: {
			layout: 'Main',
			title: `Search Product - ${APP_NAME}`,
			gtm: 'Product Search',
		},
	},
	{
		path: '/wishlist',
		name: 'wishlist',
		component: HomepageProductWishlist,
		meta: {
			layout: 'Main',
			title: `Wishlist Product - ${APP_NAME}`,
			gtm: 'Product Wishlist',
		},
	},
	{
		path: '/supplier/:supplierCode',
		name: 'supplier-products',
		component: HomepageProductSupplier,
		meta: {
			layout: 'Main',
			title: `Supplier Products - ${APP_NAME}`,
			gtm: 'Supplier Products',
		},
	},
	{
		path: '/index.html',
		name: 'index',
		component: Home,
		meta: {
			layout: 'Main',
			title: `Dashboard - ${APP_NAME}`,
			gtm: 'Dashboard',
		},
	},
	{
		path: '/welcome',
		name: 'welcome',
		component: Welcome,
		meta: {
			layout: 'Main',
			title: `Welcome - ${APP_NAME}`,
			gtm: 'Welcome',
		},
	},
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			layout: 'Main',
			title: `Login - ${APP_NAME}`,
			gtm: 'Login',
		},
	},
	{
		path: '/register',
		name: 'register',
		component: Register,
		meta: {
			layout: 'Main',
			title: `Register - ${APP_NAME}`,
			gtm: 'Register',
		},
	},
	{
		path: '/register/supplier',
		name: 'register-supplier',
		component: RegisterSupplier,
		meta: {
			layout: 'Main',
			title: `Register Supplier - ${APP_NAME}`,
			gtm: 'Register Supplier',
		},
	},
	{
		path: '/password/reset',
		name: 'resetPassword',
		component: ResetPassword,
		meta: {
			layout: 'Main',
			title: `Reset Password - ${APP_NAME}`,
			gtm: 'Reset Password',
		},
	},
	{
		path: '/phone-verification/:id?',
		name: 'phoneVerification',
		component: PhoneVerification,
		meta: {
			layout: 'Main',
			title: `Phone Verification - ${APP_NAME}`,
			gtm: 'Phone Verification',
		},
	},
	{
		path: '/profile',
		name: 'profile',
		component: Profile,
		meta: {
			layout: 'Main',
			title: `Profile - ${APP_NAME}`,
			gtm: 'Profile',
		},
	},
	{
		path: '/products',
		name: 'products',
		component: Products,
		meta: {
			layout: 'Main',
			title: `Products - ${APP_NAME}`,
			gtm: 'Products',
		},
	},
	{
		path: '/product/:slug',
		name: 'product-detail',
		component: HomepageProductDetail,
		meta: {
			layout: 'Main',
			title: `Product Detail - ${APP_NAME}`,
			gtm: 'Product Detail',
		},
	},
	{
		path: '/products/new',
		name: 'productCreator',
		component: ProductCreator,
		meta: {
			layout: 'Main',
			title: `Create Product - ${APP_NAME}`,
			gtm: 'Product - New',
		},
		props: {
			entity: 'product',
			action: 'create',
		},
	},
	// Product - Dropship
	{
		path: '/products/dropship',
		name: 'productDropship',
		component: ProductDropship,
		meta: {
			layout: 'Main',
			title: `Product Dropship - ${APP_NAME}`,
			gtm: 'Product - Dropship',
		},
		props: true,
	},
	// Product - Edit
	{
		path: '/products/:id/edit',
		name: 'productEdit',
		component: ProductCreator,
		meta: {
			layout: 'Main',
			title: `Product Edit - ${APP_NAME}`,
			gtm: 'Product - Edit',
		},
		props: route => ({
			id: route.params.id,
			entity: 'product',
			action: 'edit',
		}),
	},
	// Form - New
	{
		path: '/products/:id/form/new',
		name: 'formNew',
		component: ProductCreator,
		meta: {
			layout: 'Main',
			title: `Create Form - ${APP_NAME}`,
			gtm: 'Form - New',
		},
		props: route => ({
			id: route.params.id,
			entity: 'form',
			action: 'create',
		}),
	},
	// Form - Edit
	{
		path: '/products/:id/form/:formId',
		name: 'formEdit',
		component: ProductCreator,
		meta: {
			layout: 'Main',
			title: `Edit Form - ${APP_NAME}`,
			gtm: 'Form - Edit',
		},
		props: route => ({
			id: route.params.id,
			formId: route.params.formId,
			entity: 'form',
			action: 'edit',
		}),
	},
	{
		path: '/orders',
		name: 'submissions',
		component: Submissions,
		meta: {
			layout: 'Main',
			title: `Orders - ${APP_NAME}`,
			gtm: 'Orders',
		},
	},
	{
		path: '/orders/:id',
		name: 'submissionDetails',
		component: SubmissionDetails,
		meta: {
			layout: 'Main',
			title: `Order Details - ${APP_NAME}`,
			gtm: 'Order Details',
		},
	},
	{
		path: '/settings',
		name: 'settings',
		component: Settings,
		meta: {
			layout: 'Main',
			title: `Settings - ${APP_NAME}`,
			gtm: 'Settings',
		},
	},
	{
		path: '/settings/:type/callback/:name',
		name: 'settingsCallback',
		component: SettingsCallback,
		meta: {
			layout: 'Main',
			title: `Callback - Settings - ${APP_NAME}`,
			gtm: 'Settings Callback',
		},
	},
	{
		path: '/settings/customer-file',
		name: 'settingsCustomer',
		component: SettingsCustomerFile,
		meta: {
			layout: 'Main',
			title: `Customer File - Settings - ${APP_NAME}`,
			gtm: 'Settings - Customer File',
		},
	},
	{
		path: '/settings/notification',
		name: 'settingsNotification',
		component: SettingsNotification,
		meta: {
			layout: 'Main',
			title: `Notification - Settings - ${APP_NAME}`,
			gtm: 'Settings - Notification',
		},
	},
	{
		path: '/settings/autoresponder',
		name: 'settingsAutoresponder',
		component: SettingsAutoresponder,
		meta: {
			layout: 'Main',
			title: `Autoresponder - Settings - ${APP_NAME}`,
			gtm: 'Settings - Autoresponder',
		},
	},
	{
		path: '/settings/connections',
		name: 'settingsConnection',
		component: SettingsConnection,
		meta: {
			layout: 'Main',
			title: `Connections - Settings - ${APP_NAME}`,
			gtm: 'Settings - Connections',
		},
	},
	{
		path: '/settings/customdomain',
		name: 'settingsCustomDomain',
		component: SettingsCustomDomain,
		meta: {
			layout: 'Main',
			title: `Custom Domain - Settings - ${APP_NAME}`,
			gtm: 'Settings - Custom Domain',
		},
	},
	{
		path: '/settings/payment',
		name: 'settingsPayment',
		component: SettingsPayment,
		meta: {
			layout: 'Main',
			title: `Payment - Settings - ${APP_NAME}`,
			gtm: 'Settings - Payment',
		},
	},
	{
		path: '/settings/sms',
		name: 'settingsSms',
		component: SettingsSms,
		meta: {
			layout: 'Main',
			title: `SMS Gateway - Settings - ${APP_NAME}`,
			gtm: 'Settings - SMS',
		},
	},
	{
		path: '/settings/whatsapp',
		name: 'settingsWhatsApp',
		component: SettingsWhatsApp,
		meta: {
			layout: 'Main',
			title: `WhatsApp Gateway - Settings - ${APP_NAME}`,
			gtm: 'Settings - WhatsApp',
		},
	},
	{
		path: '/settings/store',
		name: 'settingsStore',
		component: SettingsStore,
		meta: {
			layout: 'Main',
			title: `Store - Settings - ${APP_NAME}`,
			gtm: 'Settings - Store',
		},
	},
	{
		path: '/settings/warehouse',
		name: 'settingsWarehouse',
		component: SettingsWarehouse,
		meta: {
			layout: 'Main',
			title: `Warehouse - Settings - ${APP_NAME}`,
			gtm: 'Settings - Warehouse',
		},
	},
	{
		path: '/settings/general',
		name: 'settingsGeneral',
		component: SettingsGeneral,
		meta: {
			layout: 'Main',
			title: `General - Settings - ${APP_NAME}`,
			gtm: 'Settings - General',
		},
	},
	// Settings Tags
	{
		path: '/settings/tag',
		name: 'SettingsTag',
		component: SettingsTag,
		meta: {
			layout: 'Main',
			title: `Tag - Settings - ${APP_NAME}`,
			gtm: 'Settings - Tag',
		},
	},

	// Settings Shipping
	{
		path: '/settings/shipping',
		name: 'SettingsShipping',
		component: SettingsShipping,
		meta: {
			layout: 'Main',
			title: `Shipping - Settings - ${APP_NAME}`,
			gtm: 'Settings - Shipping',
		},
	},
	// Settings Tracking
	{
		path: '/settings/tracking',
		name: 'SettingsTracking',
		component: SettingsTracking,
		meta: {
			layout: 'Main',
			title: `Tracking - Settings - ${APP_NAME}`,
			gtm: 'Settings - Tracking',
		},
	},
	{
		path: '/changelog',
		name: 'changelog',
		component: Changelog,
		meta: {
			layout: 'Main',
			title: `Changelog - ${APP_NAME}`,
			gtm: 'Changelog',
		},
	},
	// Credits
	{
		path: '/credits',
		name: 'Credits',
		component: Wallet,
		meta: {
			layout: 'Main',
			title: `Credits - ${APP_NAME}`,
			gtm: 'Credits',
		},
	},
	// Credits - Stash
	{
		path: '/credits/stash',
		name: 'Credits Stash',
		component: WalletStash,
		meta: {
			layout: 'Main',
			title: `Credits Stash - ${APP_NAME}`,
			gtm: 'Credits Stash',
		},
	},
	// Handling Fee
	{
		path: '/credits/handling-fee',
		name: 'Handling Fee',
		component: HandlingFee,
		meta: {
			layout: 'Main',
			title: `Handling Fee - ${APP_NAME}`,
			gtm: 'Handling Fee',
		},
	},
	// Billings
	// {
	// 	path: '/billings',
	// 	name: 'Billings',
	// 	component: Billings,
	// 	meta: {
	// 		layout: 'Main',
	// 		title: `Billings - ${APP_NAME}`,
	// 		gtm: 'Billings',
	// 	},
	// },
	// Billings Redirect
	// {
	// 	path: '/billings-redirect',
	// 	name: 'Billings',
	// 	component: BillingsRedirect,
	// 	meta: {
	// 		layout: 'Main',
	// 		title: `Billings Redirect - ${APP_NAME}`,
	// 		gtm: 'Billings Redirect',
	// 	},
	// },
	// callback
	{
		path: '/connection/callback',
		name: 'ConnectionCallback',
		component: ConnectionCallback,
		meta: {
			layout: 'Main',
			title: `Callback  - ${APP_NAME}`,
			gtm: 'Callback',
		},
	},
	// callback login with oo
	{
		path: '/auth/callback',
		name: 'AuthCallback',
		component: AuthCallback,
		meta: {
			layout: 'Main',
			title: `Auth Callback  - ${APP_NAME}`,
			gtm: 'Auth Callback',
		},
	},
	// Page
	{
		path: '/page/:pageSlug',
		name: 'Page',
		component: Page,
		meta: {
			layout: 'Main',
			title: `Page - ${APP_NAME}`,
			gtm: 'Page',
		},
	},
	// Inventory
	{
		path: '/inventory',
		name: 'Inventory',
		component: Inventory,
		meta: {
			layout: 'Main',
			title: `Inventory - ${APP_NAME}`,
			gtm: 'Inventory',
		},
	},
	// Members
	{
		path: '/members',
		name: 'members',
		component: Members,
		meta: {
			layout: 'Main',
			title: `Members - ${APP_NAME}`,
			gtm: 'Members',
		},
	},
	// Members Creator
	{
		path: '/members/new',
		name: 'memberCreator',
		component: MemberCreator,
		meta: {
			layout: 'Main',
			title: `Add New - Member - ${APP_NAME}`,
			gtm: 'Add Member',
		},
	},
	// Members Creator - Edit
	{
		path: '/members/:id',
		name: 'memberDetails',
		component: MemberCreator,
		meta: {
			layout: 'Main',
			title: `Member - ${APP_NAME}`,
			gtm: 'Edit Member',
		},
		props: true,
	},
	{
		path: '/brand',
		name: 'brand',
		component: Brand,
		meta: {
			layout: 'Main',
			title: `OStock Brand - ${APP_NAME}`,
			gtm: 'OStock Brand',
		},
	},
	{
		path: '/brand/list',
		name: 'brandList',
		component: BrandList,
		meta: {
			layout: 'Main',
			title: `OStock Brand List - ${APP_NAME}`,
			gtm: 'OStock Brand List',
		},
	},
	{
		path: '/direct',
		name: 'direct',
		component: Direct,
		meta: {
			layout: 'Main',
			title: `OStock Direct - ${APP_NAME}`,
			gtm: 'OStock Direct',
		},
	},
	{
		path: '/direct/list',
		name: 'directList',
		component: DirectList,
		meta: {
			layout: 'Main',
			title: `OStock Direct List - ${APP_NAME}`,
			gtm: 'OStock Direct List',
		},
	},
	{
		path: '/request-product',
		name: 'ProductRequest',
		component: ProductRequest,
		meta: {
			layout: 'Main',
			title: `Request Product - ${APP_NAME}`,
			gtm: 'Request Product',
		},
	},
	{
		path: '/request-product/list',
		name: 'ProductRequestList',
		component: ProductRequestList,
		meta: {
			layout: 'Main',
			title: `Request Product List - ${APP_NAME}`,
			gtm: 'Request Product List',
		},
	},
	// 403 - Unauthorized
	{
		path: '/403',
		component: PageUnauthorized,
		meta: {
			layout: 'Main',
			title: `403 - Page Unauthorized - ${APP_NAME}`,
			gtm: '403',
		},
	},
	// 404 - Not Found
	{
		path: '*',
		component: PageNotFound,
		meta: {
			layout: 'Main',
			title: `404 - Page Not Found - ${APP_NAME}`,
			gtm: '404',
		},
	},
	{
		path: '/notification-center',
		name: 'notification-center',
		component: NotificationCenter,
		meta: {
			layout: 'Main',
			title: `Notification Center - ${APP_NAME}`,
			gtm: 'notification-center',
			slug: 'notification-center',
		},
	},
];

export default generalRoutes;
